// extracted by mini-css-extract-plugin
export default {"credentialForm":"TreezPay_credentialForm__ZnBOZ","credentialActions":"TreezPay_credentialActions__CX0wV"};